import { BaseSelectorOption, MultiSelectorProps } from "@/types";
import { Component } from "react";
import { MultiSelector } from "./MultiSelector";

export class MultiAttributeSelector<
  T extends BaseSelectorOption = BaseSelectorOption
> extends Component<MultiSelectorProps<T>> {
  static defaultProps = {
    label: "Competencies"
  };

  constructor(props: MultiSelectorProps<T>) {
    super(props);

    this.state = {};
  }

  render() {
    const { hasNewItem = true } = this.props;

    return <MultiSelector {...this.props} hasNewItem={hasNewItem} />;
  }
}
